/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAdminSavingsTransfersRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetAdminSavingsTransfersResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getAdminSavingsTransfers = (request: GetAdminSavingsTransfersRequest, options?: CashRequestOptions) => post<GetAdminSavingsTransfersRequest, GetAdminSavingsTransfersResponse>("/2.0/cash/get-admin-savings-transfers", request, {...options, rejectOnError: true })